import React from 'react';
import SEO, { createSEO } from 'components/SEO';
import { Location } from '@reach/router';
import WebsiteLayout from 'layouts/websiteLayout';
import toolboxDetailSubNav from 'components/Toolbox/data/toolboxDetailSubNav';
import SubNav from 'components/SubNav/SubNav';
import useGlobalHeader from 'hooks/useGlobalHeader';
import useGlobalFooter from 'hooks/useGlobalFooter';

const LocationWrapper = WrappedComponent => props => (
  <Location>{location => <WrappedComponent {...props} location={location.location} />}</Location>
);

const ToolboxLayout = ({
  children,
  backgroundColor,
  theme = 'simpleHeader',
  contentfulSeo,
  ...props
}) => {
  const seo = createSEO(contentfulSeo, props);
  const isSimpleHeader = theme === 'simpleHeader';
  const subNavData = isSimpleHeader && toolboxDetailSubNav();
  const header = useGlobalHeader();
  const footer = useGlobalFooter();
  const subNav = () => <SubNav data={subNavData} simpleHeader={isSimpleHeader} mainHeader />;

  return (
    <WebsiteLayout
      header={header}
      backgroundColor={backgroundColor}
      footer={footer}
      subNav={subNav}
      theme={theme}
      layout="toolbox"
      {...props}
    >
      <SEO {...seo} />
      {children}
    </WebsiteLayout>
  );
};

export default LocationWrapper(props => ToolboxLayout(props));
